import { AreaSlider, AreaSliderValue } from "../../../components/area-slider";

const AREA_SLIDER_INITIAL_VALUE: AreaSliderValue = [0.5, 0.5];

export interface AreaWrapperProps {
  item: {
    values: string;
    [key: string]: string;
  };
  value?: AreaSliderValue;
  onChange: (e: { target: { value: AreaSliderValue } }) => void;
}
export function AreaSliderWrapper({ item, onChange, value }: AreaWrapperProps) {
  function handleValueChange(value: [number, number]) {
    onChange({ target: { value } });
  }

  return (
    <AreaSlider
      xLabel={item.v1}
      yLabel={item.v2}
      onValueChange={handleValueChange}
      initialValue={value ?? AREA_SLIDER_INITIAL_VALUE}
    />
  );
}
